import { isArray, isNull, map } from 'lodash';
import React from 'react';
import { AnalyticsProject } from '../../../common/analytics/interfaces/analyticsProject';

interface SeoData {
  description: string;
}
interface ProjectSchemaProps {
  project: AnalyticsProject;
  seoData: SeoData;
}
const ProjectSchema: React.FC<ProjectSchemaProps> = (props) => {
  const { project, seoData } = props;
  const {
    title,
    link,
    featuredImage: { url },
    location,
  } = project;
  const {
    district = [],
    road = [],
    coordinate: { latitude, longitude },
  } = location;
  const { description } = seoData;
  const getDistrict = () =>
    map(isArray(district) ? district : [district], (item) => `"${item.label}"`);
  const getRoad = () =>
    map(isArray(road) ? road : [road], (item) => `"${item.label}"`);
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Residence',
    'name': title,
    'url': link,
    'description': description,
    'branchCode': title,
    'geo': {
      '@type': 'GeoCoordinates',
      'latitude': latitude,
      'longitude': longitude,
    },
    'address': {
      '@type': 'PostalAddress',
      'addressLocality': '',
      'addressRegion': [!isNull(district) ? getDistrict() : ''],
      'streetAddress': [!isNull(road) ? getRoad() : ''],
    },
    'smokingAllowed': true,
    'image': {
      '@type': 'ImageObject',
      'url': url,
      'height': 1206,
      'width': 630,
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default ProjectSchema;
